// Charm Bar chains: keeps the product form's hidden variant id in step with the finish dropdown,
// so <s-product-form> adds the chosen chain to the cart.
class SChainPick extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('change', (event) => {
      const select = event.target;
      if (!(select instanceof HTMLSelectElement) || !select.matches('[data-chain-variant]')) return;
      const input = this.querySelector('input[name="id"]');
      if (input instanceof HTMLInputElement) input.value = select.value;
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-chain-pick')) customElements.define('s-chain-pick', SChainPick);
